import { BigNumber } from "ethers";

export const THE_GRAPH_URL =
  "https://gateway.thegraph.com/api/0dfa3e82d0ecf62f09ee6e209325e521/subgraphs/id/GtpDiNYtegkqcrojnBSDM4zGgPeJoNQfwend17DCM1nb";
// "https://api.studio.thegraph.com/query/91671/metrics-test/version/latest";

// export const EPOCH_INTERVAL = 400;
// export const EPOCH_INTERVAL = 2400;
export const EPOCH_INTERVAL = 9600;

// NOTE could get this from an outside source since it changes slightly over time
export const BLOCK_RATE_SECONDS = 0.75;

export const OHM_INITIAL_PRICE = BigNumber.from("1000000000000000000");

export const TOKEN_DECIMALS = 9;

export const INVITE_PER_PAGE = 20;

interface IPoolGraphURLS {
  [index: string]: string;
}

export const DEFAULT_INVITE_ADDRESS = "";

export const POOL_GRAPH_URLS: IPoolGraphURLS = {
  4: "https://api.thegraph.com/subgraphs/name/pooltogether/rinkeby-v3_4_3",
  1: "https://api.thegraph.com/subgraphs/name/pooltogether/pooltogether-v3_4_3",
};

interface IAddresses {
  [key: number]: { [key: string]: string };
}

export const durationList: any = {
  "1": String(180 * 60), //180days
  "2": String(150 * 60), //150days
  "3": String(100 * 60), //100days
  "4": String(60 * 60), //60days
  "5": String(30 * 30), //30days
  // "1": "15552000", //180days
  // "2": "12960000", //150days
  // "3": "8640000", //100days
  // "4": "5184000", //60days
  // "5": "2592000", //30days
};

export const addresses: IAddresses = {
  97: {
    commRoot: "0xb61298a9aE2336df0528CA73c879593E5F8A2395",
    COMMUNITY_ADDRESS: "0x351AbC68ab1bC0Ff9AA54F269b80284212Db4DAA",
    accountant: "0x057760d73035403e413259063b6EBEa6AC080142",
    pancakeFac: "0x6725F303b657a9451d8BA641348b6761A6CC7a17",
    pancakeRouter: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
    marketRecipient: "0xb61298a9aE2336df0528CA73c879593E5F8A2395",
    purchaseFundRecipient: "0x057760d73035403e413259063b6EBEa6AC080142",
    USDT_ADDRESS: "0x8BF3F9AFA97Ce934Bf38B04dC6391590cd9DC60F",
    bToken: "0x4f07C4164B1E82474B638c8D89bd4cAB0923720d",
    bTokenRecipient: "0x057760d73035403e413259063b6EBEa6AC080142",
    feeReceiver: "0xa95D95c8aD38207f8883682fB4Eb91182EdB0b70",
    OHM_ADDRESS: "0x0e6aF033A8e53ca247A376605b03b2a315887758",
    mainPair: "0x7071b9e524380EFe79fDDC706554f28F9dcab070",
    BONDINGCALC_ADDRESS: "0x7685503617b001aeeB46818C9d3A6727d1446916",
    SOHM_ADDRESS: "0xeea7DE9C793Ca7f9113782DaBf805f1Fec248291",
    rewardDistributor: "0x0Edc2D51DB96df8eAb352C1f797B04013cbBd896",
    daoRewardPool: "0xa7Eb2361e86024a066007DB36405a809Ff9058d5",
    TREASURY_ADDRESS: "0xb56980163F652f8D1714A66C6CeeC83b4C96e7F1",
    DISTRIBUTOR_ADDRESS: "0xe1C3B6BfE085FDBD7C7BEd8C3e952628Fb0cfa9a",
    STAKING_ADDRESS: "0x6f45730054E1576C049eb9299c0C7fDC0Ca21cb0",
    STAKING_WARMUP_ADDRESS: "0x31a7b3aE4A7B3001C6f0Fe52d25D58FaEC61E2a2",
    STAKING_HELPER_ADDRESS: "0x65Be7f1A7ca3c9b71d40780a07bA1aa417E22551",
    REDEEM_HELPER_ADDRESS: "0xc9Ec2f41c8cc1f13F6D114d74b617FeeF46664ea",
    DAI_BOND_ADDRESS: "0x34983153D8Bb42f3f435E03c4288B0bB0c16d3A2",
    DEPOSIT_HELPER_ADDRESS: "0x7fD6d21ca4893c6015c6283ae2030998f2936bC4",
    releasePoolHelper: "0x91eAa94B4F654D1B1a217652742C12eeeF6ac3E7",
    BNB_ADDRESS: "0x4154a3560c8F4496B3dE5151759ede7861E321eE",
    ETH_ADDRESS: "0x9DeAf13Ce24698ff9bA96bD00FEB7C22af6bAb9d",
    BTC_ADDRESS: "0x17EAc1634D37c5a543DE0ec8d0B6c2C9e2f6E1b9",
    ETH_PRICEFEED_ADDRESS: "0x143db3CEEfbdfe5631aDD3E50f7614B6ba708BA7",
    BTC_PRICEFEED_ADDRESS: "0x5741306c21795FdCBb9b265Ea0255F499DFe515C",
    stakingReleasePool: "0x388608cFF6872e038ab269f7C3D6A6Fbbf872ddf",
    contributionReleasePool: "0x20b5a0277EE4cDa55eb6381aCb9F85F0ea50620e",
    USDT_STABLE_BOND_ADDRESS: "0x3074EB3afEA54bCDbDd4191dE351488aFCa71705",
    airdrop: "0xddeE139d738e30c085205Af96344265e87b28161",
    WBNB_ADDRESS: "0x4f07C4164B1E82474B638c8D89bd4cAB0923720d",
    tokenName: "Revolution",
    tokenSymbol: "REV",
    stokenName: "Staked Revolution",
    stokenSymbol: "sREV",
    roleManager: "0x585EaCD217d215DB2eB4707EC9C382D13ff2b695",
    contributionReleasePoolV2: "0xa2DABAAD664F7DAe0296b2a02E5a185A8B73b9aa",
    View: "0x9cfFAFC90Cb2cbF074c3163318B80EE40C0613F4",
    aTokenFeeReceiver: "0x18e5590a9A30F37bD6F56530066dfB6EdC45b657",
    restakingPool90: "0xAF4d5f306764B400CAf9c93162725293F4701a16",
    restakingPool180: "0xBB31Dc95EaaaFb43CfaB2A454A90b3E48166e669",
    restakingPool360: "0xD68a6d30c5219C5DE71260b180C8e1Fd81aCa20a",
    aTokenSymbol: "REVT",
    aTokenName: "REVT",
    directRewardDefaultRecipient: "0xb61298a9aE2336df0528CA73c879593E5F8A2395",
    aTokenFeeRecipient: "0xb61298a9aE2336df0528CA73c879593E5F8A2395",
    aTokenMultiSignAddr: "0xb61298a9aE2336df0528CA73c879593E5F8A2395",
    aTokenAddress: "0xD1119eb252Ee74fC859a16C505A9f9e282d478b9",
    aTokenMainPair: "0xac7f385524E97dB7D47E5168703D2f84c30c3A02",
    consensusRewardDistributor: "0xa43BE40Cbf097a63aE385C36B63FbcE94D4faC7e",
    flashRestaking: "0x8132FB6E60fa03929972292FDd9b876C69Fedd13",
    restakingRewardPool: "0x0d3f0BE55FA7df584F2772E0d7A98d47bc7F206B",
  },

  56: {
    commRoot: "0x3E4901a01c1C9625e6927872c3AD54eB0d58B6eA",
    community: "0xFf26f3D2324Dc1C8c5813feC07c1b3630f5da329",
    USDT_ADDRESS: "0x55d398326f99059ff775485246999027b3197955",
    pancakeRouter: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
    pancakeFac: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
    COMMUNITY_ADDRESS: "0xFf26f3D2324Dc1C8c5813feC07c1b3630f5da329",
    BNB_ADDRESS: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    WBNB_ADDRESS: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    ETH_ADDRESS: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
    BTC_ADDRESS: "0x0555e30da8f98308edb960aa94c0db47230d2b9c",
    ETH_PRICEFEED_ADDRESS: "0x9ef1B8c0E4F7dc8bF5719Ea496883DC6401d5b2e",
    BTC_PRICEFEED_ADDRESS: "0x264990fbd0A4796A3E3d8E37C4d5F87a3aCa5Ebf",
    bToken: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    marketRecipient: "0xf0CB2E8D265ff5e7A128C8f22B61Ff81559C6ada",
    purchaseFundRecipient: "0x9B49a9420Eb0440e7A1c911E894133488CF44847",
    bTokenRecipient: "0x0933D09B9106209a5e58C590aF1E4c22d2F5792f",
    accountant: "0xe0dcb9c378362902679bed1d701c482ca3d83db5",
    treasuryDaoWallet: "0xe8b1Aa6dBF9ED6Ac49286e49514852d3a00a8C4e",
    treasuryDaoWalletNew: "0x0489Ba2F65e54FdC94D1F8B2d72c7527811aC0aC",
    roleManager: "0xE4B25E3a628dD91Ed8bfcF09785C676CcB829430",
    feeReceiver: "0x3087e9797873200Bcd9151c7241B87cc292A7fe5",
    OHM_ADDRESS: "0x3595AfFf15A7ccaeeEb787Fd676f7A297319C24c",
    mainPair: "0x5a5fD4DBF70747E684F43B43aB53d4b0C733293D",
    BONDINGCALC_ADDRESS: "0x3dC6479A654895a71C8361dd6F88A235bf7eFc96",
    SOHM_ADDRESS: "0x6d6C16A3cbD318f3000e33cFD27662cF00F7E7c1",
    releasePoolHelper: "0xc42b129B08951531A304B94C9eda0d3C10Aa6C24",
    contributionReleasePool: "0x0FcE80b9029b95AF97C9590890ae3B1de612ac40",
    rewardDistributor: "0x596bE6AEd2Cb7D57211fA0a98Ca32cE5dC6A8B57",
    daoRewardPool: "0x17f4275D4f03Ab08a8814c05F2EE04FfDa6F93a7",
    TREASURY_ADDRESS: "0x585386a67E817849Ef5211f433432b1D28DD7Ce8",
    DISTRIBUTOR_ADDRESS: "0xAf1A5bC6857dd43BB121C76BA6FA5eB1ee683D85",
    stakingReleasePool: "0xa419A745EAfc4D8764d9324A2Ce4193Ac0C93F93",
    STAKING_ADDRESS: "0x6bCd1273eba684Ff62614e41eff87123113112D1",
    STAKING_WARMUP_ADDRESS: "0xC0b2713af9879E0d492F8BD71c61142708C3dfC2",
    STAKING_HELPER_ADDRESS: "0x190ec1f8AcF063665375235490b5915ca3fF1062",
    REDEEM_HELPER_ADDRESS: "0xe71b286a912791AA4b7fDF2cb902133381Aba96a",
    DAI_BOND_ADDRESS: "0xf9613C5ADE16Aa0A2dd2E3341d4d32b2D71c8689",
    DEPOSIT_HELPER_ADDRESS: "0x1fAf613d0bF6C0238B3E80954989A6D4984331a4",
    USDT_STABLE_BOND_ADDRESS: "0x91D743F68142622e29abEC08F07ea34F0b8197B0",
    View: "0x2Ed55f1D2666EE2E80658fba4E61A6473046f261",
    daoPoolAdmin: "0x36A2C42de2d832a4ecEEd8547ae77526A89a3C60",
    contributionReleasePoolV2: "0xdf83B8cC5F70EDf17cf903bE53f2842f39ef4D72",
    aTokenSymbol: "T",
    aTokenName: "T",
    directRewardDefaultRecipient: "0x38B67F4e7899912aa5364BeF5cdfFd6ae371d47b",
    aTokenFeeRecipient: "0x187566C4Df6A56cDb8412Bf3CBEe24459880BaB0",
    aTokenMultiSignAddr: "0x02C69F5694d7021AAC6D6b8549F6A1Dae675A1d3",
    aTokenFeeReceiver: "0x3969B3fC908E4927E9242A54338233e527119Ce9",
    aTokenAddress: "0x13107fDa6CA5961432FA7d66bDBB65d70d44778F",
    aTokenMainPair: "0x542FD248e7deBFfEbC8b3626F68855D0325Bcca8",
    restakingPool90: "0xa74045B7e2f0B23851F0519718DF01A0eFf41DF0",
    restakingPool180: "0x4e72bD160914E9c8b577bd8E68e8cE2FC07B5EE3",
    restakingPool360: "0xe41aC412698a32DF560aa410b64515BF40dbf828",
    consensusRewardDistributor: "0xfCBb41AA2890F446f3EF67168A2558A53D503d9a",
    flashRestaking: "0x858c8C8684705d876E4cDbA8b3Dc29B63893698C",
    restakingRewardPool: "0x7f499e53235b51C7620bc5cBA237708C3687b5E4",
  },
};
